export default {
  _getUserData() {
    if (this._dev && !this._useStaging) {
      this.$log.warn('You are in dev mode and are looking at mock data. To see staging data, click the db on the bottom right.');
    }
    return this._SEND([{ name: 'getUserData' }]);
  },
  _fallbackGetUserData() {
    return this._getUserData();
  },
  _setUpFirstLogin(user) {
    return this._SEND([{
      name: 'setUpFirstLoginData',
      payload: {
        user,
        identityId: this.identityId,
      },
    }]);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/aws/dynamodb.js